module.exports = __webpack_public_path__ + "img/open_new_tab_black.bed43b1b.svg";